export const PURE_MULTIPLE_CHOICE_EXERCISE = 'PureMultipleChoiceExercise';
export const EXPORTED_EXERCISES = [PURE_MULTIPLE_CHOICE_EXERCISE];